import React, { Component } from 'react'
import { connect } from 'react-redux'
import { slide as Menu } from 'react-burger-menu'
import { NavLink } from 'react-router-dom'
import { signOut } from '../../store/actions/authActions'
import { updateSortVisible } from '../../store/actions/restaurantActions'

class Burger extends Component {
  
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  toggleMenu (state) {
    this.setState(state => ({menuOpen: !state.menuOpen}))
  }

  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})  
  }

  onKeyDown(e){
    switch(e.keyCode){
        case 37: case 39: case 38:  case 40: // Arrow keys
        case 32: e.preventDefault(); break; // Space
        default: break; // do not block other keys
    }
  }

  handleSignOut(state){
   this.setState(state => ({menuOpen: !state.menuOpen}));
   this.props.signOut(); 
  }

  handleSortVisible(){
    if(!this.props.restaurant.sortVisible){
      this.props.updateSortVisible(true);  
      document.body.style.overflow = 'hidden';
    }
    else{
      this.props.updateSortVisible(false);
      document.body.style.overflow = 'scroll';
    }
    this.setState({menuOpen:false});
  }

  render () {
    //prevent window scrolling when menu open
    if(this.state.menuOpen){
      window.addEventListener("keydown",this.onKeyDown,false);
    }
    else{
      window.removeEventListener("keydown",this.onKeyDown);
    }

    const { auth } = this.props;
    // NOTE: You also need to provide styles, see https://github.com/negomi/react-burger-menu#styling
    return (
      <Menu disableAutoFocus
          isOpen={this.state.menuOpen}
          onStateChange={(state) => this.handleStateChange(state)}
        >
        <NavLink to='/' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Home</NavLink>
        {/*{window.innerWidth < 715 && <a onClick={()=>this.handleSortVisible()}>Sorting Options</a>}*/}
        {window.innerWidth < 715 && <NavLink to='/sortingOptions' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Sorting Options</NavLink>}
        <NavLink to='/game/createGame' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Tournament</NavLink>
        <NavLink to='/create' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Add a Restaurant</NavLink>
        <NavLink to='/about' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>About</NavLink>
        <NavLink to='/blog' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Blog</NavLink>
        {/*<NavLink to={'/UserDashboard/' + this.props.auth.uid} className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>User Dashboard</NavLink>*/}
        <NavLink to='/contact' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Contact & Feedback</NavLink>
        <NavLink to='/settings' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Settings</NavLink>
        <NavLink to='/support' className="burgerItem" onClick={(state)=>this.toggleMenu(state)}>Support This Project</NavLink>
        {/*<a onClick={(state)=>this.handleSignOut(state)}>Sign Out</a>*/}
        <a href="https://wlvirginialottery.adsrv.eacdn.com/C.ashx?btag=a_106b_49c_&affid=62&siteid=106&adid=49&c=">
         <img src="https://www.valottery.com/-/media/val/images/promos/logo/desktoptopnavlogo202110121.ashx?h=60&w=226&la=en&hash=1DF3E9DAE14C92681DAA33FA85319776064096D5"/ >
        </a>
      </Menu>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    restaurant: state.restaurant
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
    updateSortVisible: (sortVisible) => dispatch(updateSortVisible(sortVisible))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Burger)